/** External Dependencies */
import styled from 'styled-components';
import Input from '@scaleflex/ui/core/input';
import Select from '@scaleflex/ui/core/select';

const StyledFontFamilySelect = styled(Select)`
  width: 88px;
  margin: 0 4px;
  background: ${({ theme }) => theme.palette['bg-primary-active']};

`;

const StyledFontSizeInput = styled(Input)`
  width: 70px;
  margin: 0 4px;
  background: ${({ theme }) => theme.palette['bg-primary-active']};

`;

export { StyledFontFamilySelect, StyledFontSizeInput };
